import BaseEntity from './BaseEntity'
import createGallery from './Gallery'
import createReview from './Review'
import i18n from '../utils/i18n'
import moment from 'moment'

const Props = {
  id: undefined,
  firstName: undefined,
  lastName: undefined,
  phoneticFirstName: undefined,
  phoneticLastName: undefined,
  displayName: undefined,
  avatarImageUrl: undefined,
  message: undefined,
  profile: undefined,
  gallery1: undefined,
  gallery2: undefined,
  gallery3: undefined,
  supportedDanceKinds: undefined,
  reviewCount: undefined,
  reviewRateAverage: undefined,
  reviews: undefined,
  publishedTime: undefined,
}

class Coach extends BaseEntity {
  constructor(params) {
    super(params)
    this.gallery1 = createGallery(params.gallery1 || {})
    this.gallery2 = createGallery(params.gallery2 || {})
    this.gallery3 = createGallery(params.gallery3 || {})
    if (params.reviews) {
      this.reviews = params.reviews.edges.map((r) => createReview(r.node))
    }
  }

  get name() {
    return this.displayName || [this.lastName, this.firstName].join(' ')
  }

  get localeSupportedDanceKinds() {
    return this.supportedDanceKinds.map((d) => i18n.tc(`danceKind.${d}`))
  }

  get checkIsNew() {
    let publishedTime = moment(this.publishedTime)

    return moment().diff(publishedTime, 'days') <= 30
  }
}

export default function createCoach(params) {
  const props = {
    ...params.coach,
    ...params.reviewResult,
    publishedTime: params.publishedTime,
  }
  const attr = Object.assign({}, Props, props)
  return Object.freeze(new Coach(attr))
}
